import {Component, OnInit} from '@angular/core';
import {OrderItem} from '~/app/core/common/models/orderItem';
import {InventoryDetails} from '~/app/core/common/models/inventoryDetails';
import {InventoryService} from '~/app/core/common/services/inventory.service';
import {DeviceHelperComponent} from '~/app/shared/helpers/device-helper';
import {OrderItemService} from '~/app/core/common/services/order-item.service';
import {KendoGridHelperComponent} from '~/app/shared/helpers/kendo-grid-helper';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-add-items-dialog',
    templateUrl: './add-items-dialog.component.html',
    styleUrls: ['./add-items-dialog.component.scss']
})
export class AddItemsDialogComponent implements OnInit {

    public columns: any[];
    public _orderItemsSelected: OrderItem[] = [];
    public _inventoryItemSelected: InventoryDetails[] = [];
    _inventoryState: any;
    gridData: any;
    inventoryGridData: any;
    public _isTablet: boolean;
    public _stateItemsTable: any;

    constructor(public dialogRef: MatDialogRef<AddItemsDialogComponent>,
                public inventoryService: InventoryService,
                private _deviceHelper: DeviceHelperComponent,
                public orderItemService: OrderItemService,
                public _kendoHelper: KendoGridHelperComponent) {

    }

    get stateItemsTable(): any {
        return this._stateItemsTable;
    }

    set stateItemsTable(value: any) {
        this._stateItemsTable = value;
    }

    public _selectedCallback = (args) => args.dataItem;

    public _removeCallBack = (args) => args.dataItem;

    ngOnInit() {
        this._isTablet = this._deviceHelper.isTablet();
        this.loadItemsGrid();
    }

    public addSelectedItemsToList() {
        this._orderItemsSelected.map((result) => {
            if (!this.checkForDuplicates(result.itemNo.toString())) {
                const inventoryItem = this.createInventoryItemFromOrderItem(result);
                this.inventoryService.inventoryDetails.details.push(inventoryItem);
            }

        });
    }

    public removeSelectedItems() {
        this._inventoryItemSelected.forEach(item => {
            let index: number;
            index = this.inventoryService.inventoryDetails.details.indexOf(item);
            this.inventoryService.inventoryDetails.details.splice(index, 1);
        });
    }

    loadItemsGrid() {
        this._stateItemsTable = this._kendoHelper.createStateForGrid();
        this._kendoHelper.processItems(this.orderItemService.orderItems, this._stateItemsTable);
        this.gridData = this._kendoHelper._gridDataHelperItems;
        this._inventoryState = this._kendoHelper.createStateForGrid();
        this.inventoryGridData = this._kendoHelper
            .processItemsAndReturn(this.inventoryService.inventoryDetails.details, this._inventoryState);
    }

    copyBtnClicked() {
        this.addSelectedItemsToList();

    }

    checkForDuplicates(id: string): boolean {
        let tempCheck = false;
        this.inventoryService.inventoryDetails.details.map((value) => {
            if (value.customerItem === id) {
                tempCheck = true;
            }
        });
        return tempCheck;
    }

    removeBtnClicked() {
        this.removeSelectedItems();
    }

    dataStateChangeInventoryDetails(state: any) {
        this._inventoryState = state;
        const invData = this._kendoHelper.processItemsAndReturn(this.inventoryService.inventoryDetails.details, this._inventoryState);
        this.inventoryGridData = invData;
    }

    dataStateChangeItemDetails(state: any) {
        this._stateItemsTable = state;
        const itemData = this._kendoHelper.processItemsAndReturn(this.orderItemService.orderItems, this._stateItemsTable);
        this.gridData = itemData;
    }

    cancelOnClick() {
        this.dialogRef.close();
    }

    private createInventoryItemFromOrderItem(orderItem: OrderItem) {
        const inventoryItem = new InventoryDetails();
        inventoryItem.amount = 0;
        inventoryItem.customerItem = orderItem.itemNo.toString();
        inventoryItem.description = orderItem.description;
        inventoryItem.price = orderItem.perCost;
        inventoryItem.purchaseUOM = orderItem.unitOfMeasure.toString().substring(0, 2);
        inventoryItem.packSize = +orderItem.unitOfMeasure.toString().split('-').pop().slice(0, -2);
        inventoryItem.packUOM = orderItem.unitOfMeasure.toString().substring(orderItem.unitOfMeasure.toString().length - 2);
        inventoryItem.uomPackSize = orderItem.unitOfMeasure.toString();
        inventoryItem.qty = 0;
        return inventoryItem;
    }
}

export class InventoryAddModel {
    constructor(public title: string) {
    }
}
